var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentmanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M9,9.05V7.88a.36.36,0,0,0-.33-.38H5.33V5.22a2.55,2.55,0,0,0,2-2.59A2.49,2.49,0,0,0,5,0,2.49,2.49,0,0,0,2.67,2.63a2.55,2.55,0,0,0,2,2.59V7.5H1.33A.36.36,0,0,0,1,7.88V9.05A1.48,1.48,0,0,0,0,10.5,1.42,1.42,0,0,0,1.33,12a1.43,1.43,0,0,0,1.34-1.5,1.48,1.48,0,0,0-1-1.45v-.8h3v.8a1.47,1.47,0,0,0-1,1.45A1.42,1.42,0,0,0,5,12a1.42,1.42,0,0,0,1.33-1.5,1.47,1.47,0,0,0-1-1.45v-.8h3v.8a1.48,1.48,0,0,0-1,1.45A1.43,1.43,0,0,0,8.67,12,1.42,1.42,0,0,0,10,10.5,1.48,1.48,0,0,0,9,9.05ZM3.33,2.63A1.78,1.78,0,0,1,5,.75,1.78,1.78,0,0,1,6.67,2.63,1.78,1.78,0,0,1,5,4.5,1.78,1.78,0,0,1,3.33,2.63ZM2,10.5a.72.72,0,0,1-.67.75.76.76,0,0,1,0-1.5A.72.72,0,0,1,2,10.5Zm3.67,0a.72.72,0,0,1-.67.75.75.75,0,0,1,0-1.5A.72.72,0,0,1,5.67,10.5Zm3,.75a.75.75,0,0,1,0-1.5.76.76,0,0,1,0,1.5Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentmanagement);
export default __webpack_public_path__ + "static/media/contentmanagement.503e666b5c0140553a118425c28f8241.svg";
export { ForwardRef as ReactComponent };